/**
 * getColumnId — the single source of truth mapping a custom `Column<TData>` to a
 * stable react-table column id.
 *
 * This is the ONLY place a `Column<TData>` becomes a react-table id. It is used by:
 *   1. `columnAdapter.ts` (the adapter's `ColumnDef.id`),
 *   2. the responsive `columnVisibility` projection (CanonicalTable, plan Task 7), and
 *   3. the `getVisibleLeafColumns()` → raw `Column<TData>` remap (CanonicalTable, plan Task 5).
 *
 * If these used different id schemes, the responsive `columnVisibility` projection keys
 * would not match react-table's leaf ids and responsive hiding would silently no-op
 * (every column always visible). They MUST share this one function. (architecture.md
 * Decision 3 / B2.)
 *
 * `Column.id` is `keyof TData | ''` (see `types.ts`); the empty-string sentinel marks a
 * column with no accessor (e.g. an action/derived column), which falls back to a
 * positional id.
 */
import { Column } from '@/components/table/types';

export function getColumnId<TData>(col: Column<TData>, index: number): string {
  return col.id !== '' ? String(col.id) : `col-${index}`;
}
